import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import './index.scss';
import './portal.css';
import './i18n';

const win: any = window;

!!!win["lang"] && (win["lang"] = "en");
document.documentElement.lang = win["lang"];
let dir = win["lang"] === null || win["lang"] === "en" ? "ltr" : "rtl";
const lang = win['lang'];
const rtl = lang === 'ar';

ReactDOM.render(
  <React.StrictMode>
    <App dir={dir} rtl={rtl} />
  </React.StrictMode>,
  document.getElementById('root') as HTMLElement
);
